<template>
    <div>
        <az-loading />

        <div class="alert alert-info text-center mt-3">{{ this.path }}</div>
    </div>
</template>

<script>
import AzLoading from './AzLoading.vue';
export default {
    props: ['path'],

    components: { 
        AzLoading,
    },

    mounted() { 
        this.$nextTick(() => { 
            this.$router.push({ path: this.path });
        });
    }
}
</script>